// ==============================|| OVERRIDES - PAPER ||============================== //

export default function Paper(borderRadius) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: borderRadius || '8px'
        },
        rounded: {
          borderRadius: `${borderRadius}px`
        }
      }
    }
  };
}
